import React, {useState} from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import {pathServer} from "../../../shared/constants/Constants";
import PSIcon from "../../PSIcon";
import {PopoverOptions} from "../index";
import { ModalConfirm } from '../../organisms';

const ItemHistory = React.forwardRef(({ className, index, data, onselect, onDelete,...props}, ref) =>{
  const [showPopover, setShowPopover] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
	const [confirmation, setConfirmation] = useState(0);

  const onClickShowPopover = () => {

  };


  return (
    <tr key={index} ref={ref} className={`container-itemHistory ${className}`} onClick={()=>onselect(data)}>
      <td className="container-content">
        <div className="d-flex">
          <div className="info-graphic">PP</div>
          {/*<img src={`${pathServer.PATH_IMG}calendar/${index+1}.svg`} className="img-month"/>*/}
          <div>
            <span className="margin-text">{data? data.description: ''}</span>
          </div>
        </div>
      </td>
      <td className="container-content">
        <div className="d-flex">
          <PSIcon type="smallCalendar"/>
          <span className="margin-text">{data? data.date: ''}</span>
        </div>
      </td>
      <td>
        <div className="d-flex">
          <span  className="mr-1">{data  && data.status ? data.status :''}</span>
          <PSIcon type='check' className="mr-1-5"/>
          <div className="container-options">
            <PSIcon type='options2' onClick={()=>setShowPopover(!showPopover)}/>
            {
              showPopover && <PopoverOptions className="popover-options" onDelete ={()=>setConfirmation(data.id)} onShow={()=>{setShowPopover(false)}} />
            }

          </div>
        </div>
      </td>
			<ModalConfirm
				title = {'Eliminar Noticia'}
				question = {"¿Desea eliminar esta noticia?"}
				onCancel = { () => {setConfirmation(0)} }
				onAccept = { () => {onDelete(confirmation); setConfirmation(0) } }
				openModal = { confirmation !== 0 }
			/>
    </tr>
  )

});

ItemHistory.displayName = 'ItemHistory';

ItemHistory.defaultProps = {
  className: '',
  index: 1,

};

ItemHistory.propTypes = {
  className: PropTypes.string,
  index: PropTypes.integer,
};

export default ItemHistory;
